// @flow

import React from 'react'
import styled from 'styled-components'
import { mediaMax, mediaMin } from 'frontend_core/dist/styles/media'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import Title from 'components/atoms/Title'
import LinkText from 'components/atoms/LinkText'
import Icon from 'components/atoms/Icon'
import FavoriteListCard, {
  type PropTypes as FavoriteListCardType,
} from 'components/molecules/FavoriteListCard'
import MainContents from 'components/templates/MainContents'
import NoItemDescription from 'components/atoms/NoItemDescription'
import Loading from 'components/atoms/Loading'
import ModalForm from 'components/organisms/ModalForm'

const Heading = styled.div`
  display: table;
  width: 100%;
`

const TitleWrapper = styled.div`
  display: table-cell;
`

const LinkTextWrapper = styled.div`
  display: table-cell;
  text-align: right;
  vertical-align: bottom;
`

const FavoriteListCardContent = styled.div`
  margin-top: ${spacing.medium_2}px;
`

const FavoriteListCardList = styled.ul`
  ${mediaMax.phone`
    display: block;
    width: 100%;
    margin: 0;
  `} ${mediaMin.phone`
    margin: -${spacing.medium_2}px 0 0 -${spacing.medium_2}px;
  `};
`

const FavoriteListCardListItem = styled.li`
  ${mediaMax.phone`
    display: block;
    width: 100%;
    :not(:first-child) {
      margin: ${spacing.medium_2}px 0 0;
    }
  `} ${mediaMin.phone`
    display: inline-block;
    width: 240px;
    margin: ${spacing.medium_2}px 0 0 ${spacing.medium_2}px;
  `};
`

const LoadingContainer = styled.div`
  padding: ${spacing.medium}px 0;
  text-align: center;
`

export type PropTypes = {
  favoriteList: Array<FavoriteListCardType>,
  isLoading: boolean,
  isOpenFavoriteListCreateModal: boolean,
  onClickCloseModal: Function,
  onClickOpenModal: Function,
  newListName: string,
  isSubmittedCreateNewListName: boolean,
  onSubmitCreateNewListName: Function,
  onChangeNewListName: Function,
  onClickCreateList: Function,
}

export default class FavoriteListPage extends React.Component<PropTypes, *> {
  props: PropTypes

  render() {
    const {
      favoriteList,
      isLoading,
      isOpenFavoriteListCreateModal,
      onClickCloseModal,
      onClickOpenModal,
      newListName,
      onChangeNewListName,
      onSubmitCreateNewListName,
      isSubmittedCreateNewListName,
      onClickCreateList,
    } = this.props

    return (
      <MainContents>
        <Heading>
          <TitleWrapper>
            <Title>{i18n.t('page.dashboard.favorite.favoriteList')}</Title>
          </TitleWrapper>
          <LinkTextWrapper>
            <LinkText
              fontSizePc={fontSize.medium}
              fontSizeSp={fontSize.small_3}
              onClick={onClickOpenModal}
            >
              <Icon className="fa fa-plus" positionType="left" />
              {i18n.t('page.dashboard.favorite.createNewList')}
            </LinkText>
          </LinkTextWrapper>
        </Heading>
        <ModalForm
          isActive={isOpenFavoriteListCreateModal}
          title={i18n.t('favorite.createNewList')}
          textList={[i18n.t('favorite.inputGuide')]}
          negativeButton={{
            text: i18n.t('page.shared.cancel'),
            onClick: onClickCloseModal,
          }}
          positiveButton={{
            text: i18n.t('page.shared.create'),
            onClick: onClickCreateList,
          }}
          value={newListName}
          placeholder={i18n.t('favorite.inputPlaceholder')}
          onClickClose={onClickCloseModal}
          onChange={onChangeNewListName}
          errorMessage={
            isSubmittedCreateNewListName &&
            !newListName &&
            i18n.t('favorite.inputGuide')
          }
        />
        <FavoriteListCardContent>
          {favoriteList.length === 0 && !isLoading ? (
            <NoItemDescription
              children={i18n.t('page.dashboard.favorite.noneFavoriteList')}
            />
          ) : (
            <FavoriteListCardList>
              {favoriteList.map((favorite, index) => (
                <FavoriteListCardListItem key={index}>
                  <FavoriteListCard {...favorite} />
                </FavoriteListCardListItem>
              ))}
            </FavoriteListCardList>
          )}
          {isLoading && (
            <LoadingContainer>
              <Loading />
            </LoadingContainer>
          )}
        </FavoriteListCardContent>
      </MainContents>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/FavoriteListPage/index.jsx